(function () {
  'use strict';

  angular.module('MktzapApp.Controllers')
    .controller('ActiveSenderController', activeSender);

  activeSender.$inject = ['$rootScope', 'LangService', 'CompanyService', 'NotificationService'];

  function activeSender ($rootScope, LangService, CompanyService, NotificationService) {
    var vmActiveCtrl = this;

    LangService
      .getPageLabels({ 'page': 'menu.config.activeSender' })
      .$promise
      .then(function (data) {
        vmActiveCtrl.labels = data.lang;
      });

    CompanyService
      .loadMetadata()
      .$promise
      .then(function (data) {
        vmActiveCtrl.metadata = data;
      })
      .catch(function (error) {
        NotificationService.errorHandler(error, vmActiveCtrl.labels.errorMetadata);
      });

    vmActiveCtrl.allow = function (key) {
      CompanyService
        .saveMetadata(vmActiveCtrl.metadata)
        .$promise
        .then(function (data) {
          vmActiveCtrl.metadata = data;
          $rootScope.company_metadata = vmActiveCtrl.metadata;
          NotificationService.successHandler(data, vmActiveCtrl.labels.configUpdated);
        })
        .catch(function (error) {
          NotificationService.errorHandler(error, vmActiveCtrl.labels.notActive);
        });
    };
  }
})();
